import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import InputSearch from "../../../components/InputSearch/InputSearch";
import Table from "../../table/Table";
import RankingIndicator from "./RankingIndicator/RankingIndicator";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { toast, ToastContainer } from "react-toastify";

import { ReactComponent as IconSearch } from "../../../build/images/icons/search02.svg";

import "./rankings.css";
import { format } from "date-fns";
import Paperplane from "../../Loading/Paperplane/Paperplane";
import {
  getRankingGroupCall,
  getRankingGroupCallCsat,
  getRankingGroupCallEnviadas,
  getRankingServiceCall,
  getRankingServiceCallCsat,
  getRankingServiceCallEnviadas,
} from "../../../actions";
import { groupBy } from "../../../utils/groupBy";
import axios from "axios";

export default function Rankings() {
  //REDUX - Selectors
  const agentDashboardFilter = useSelector(
    (state) => state.agentDashboardFilter
  );

  //STATES
  const [searchData, setSearchData] = useState("");
  const [tabActive, setTabActive] = useState("Unidades");
  const [filteredUnityData, setFilteredUnityData] = useState([]);
  const [unityRawData, setUnityRawData] = useState([]);
  const [filteredInsuranceData, setFilteredInsuranceData] = useState([]);
  const [insuranceRawData, setInsuranceRawData] = useState([]);
  const [loadingUnity, setLoadingUnity] = useState(false);
  const [loadingInsurance, setLoadingInsurance] = useState(false);
  const [errorInsurance, setErrorInsurance] = useState(false);
  const [errorUnit, setErrorUnit] = useState(false);

  const hasError = errorInsurance || errorUnit;

  //FUNCTIONS
  function feeSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    const isString =
      !!rowDataA &&
      typeof rowDataA.data === "string" &&
      !!rowDataB &&
      typeof rowDataB.data === "string";

    if (isString) {
      const hasFeeA = rowDataA.data.includes("%");
      let numberA = hasFeeA ? Number(rowDataA.data.replace("%", "")) : 0;

      const hasFeeB = rowDataB.data.includes("%");
      let numberB = hasFeeB ? Number(rowDataB.data.replace("%", "")) : 0;

      if (numberA > numberB) return -1;
      if (numberB > numberA) return 1;
      if (numberA === numberB) return 0;
    }

    return 0;
  }

  function npsSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    const isString =
      !!rowDataA &&
      typeof rowDataA.data === "string" &&
      !!rowDataB &&
      typeof rowDataB.data === "string";
    if (isString) {
      const hasNpsA = rowDataA.data.includes("NPS");
      let numberA = hasNpsA ? Number(rowDataA.data.replace(" NPS", "")) : 0;

      const hasNpsB = rowDataB.data.includes("NPS");
      let numberB = hasNpsB ? Number(rowDataB.data.replace(" NPS", "")) : 0;

      if (numberA > numberB) return -1;
      if (numberB > numberA) return 1;
      if (numberA === numberB) return 0;
    }

    return 0;
  }
  function defaultSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "string" &&
      typeof rowDataB.data === "string"
    ) {
      const objectRowA = rowDataA.data.toLowerCase();
      const objectRowB = rowDataB.data.toLowerCase();

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    } else if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "number" &&
      typeof rowDataB.data === "number"
    ) {
      const objectRowA = rowDataA.data;
      const objectRowB = rowDataB.data;

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    }

    return 0;
  }

  /*
  function defaultSorting(rowA, rowB, columnId) {
    const objectRowA = rowA.original[columnId].data;
    const objectRowB = rowB.original[columnId].data;

    if (objectRowA > objectRowB) return -1;
    if (objectRowB > objectRowA) return 1;
    return 0;
  }
*/

  async function updateGroupsTableContent(
    startDate,
    endDate,
    idsChannel,
    idsAvaliation,
    source,
    idsGroups
  ) {
    setErrorUnit(false);
    setLoadingUnity(true);

    let updatedGroupData = [];

    const response = await getRankingGroupCall(
      startDate,
      endDate,
      idsChannel,
      idsAvaliation,
      source,
      idsGroups
    );
    const hasResponse = !!response && response.status === 200;

    const responseTotalSended = await getRankingGroupCallEnviadas(
      startDate,
      endDate,
      idsChannel,
      idsAvaliation,
      idsGroups
    );

    const hasResponseTotalSended =
      !!responseTotalSended && responseTotalSended.status === 200;

    const responseCsatGrade = await getRankingGroupCallCsat(
      startDate,
      endDate,
      idsChannel,
      idsAvaliation
    );

    const hasResponseCsatGrade =
      !!responseCsatGrade && responseCsatGrade.status === 200;

    if (hasResponse && hasResponseTotalSended && hasResponseCsatGrade) {
      const data = response.data;
      const hasData = !!data && data.length > 0;

      const dataTotalSended = responseTotalSended.data;
      const hasDataTotalSended =
        !!dataTotalSended &&
        Array.isArray(dataTotalSended) &&
        dataTotalSended.length > 0;

      const dataCsat = responseCsatGrade.data;
      const hasDataCsat =
        !!dataCsat && Array.isArray(dataCsat) && dataCsat.length > 0;

      if (hasData) {
        const groupedData = groupBy(data, "id_grupo");
        const hasGroupedData = !!groupedData;
        if (hasGroupedData) {
          let index = 0;
          for (const groupId in groupedData) {
            const dataOfGroup = groupedData[groupId];
            const hasDataOfGroup = !!dataOfGroup && dataOfGroup.length > 0;
            const infosAboutTotalSendedOfThisGroup = dataTotalSended.find(
              (sendedInfoOfThisGroup) => {
                const hasId_grupo =
                  sendedInfoOfThisGroup.id_grupo !== null &&
                  sendedInfoOfThisGroup.id_grupo !== undefined;
                const hasGroupId = groupId !== null && groupId !== undefined;
                if (hasId_grupo && hasGroupId) {
                  return sendedInfoOfThisGroup.id_grupo.toString() === groupId;
                } else {
                  return false;
                }
              }
            );
            const hasInfosAboutTotalSendedOfThisGroup =
              !!infosAboutTotalSendedOfThisGroup;
            const qtde_envio = hasInfosAboutTotalSendedOfThisGroup
              ? Number(infosAboutTotalSendedOfThisGroup.qtde_enviada)
              : 0;
            const qtde_avaliou = hasInfosAboutTotalSendedOfThisGroup
              ? Number(infosAboutTotalSendedOfThisGroup.qtde_avaliada)
              : 0;

            // pega a nota CSAT
            let csatGrade = 0;
            if (hasDataCsat) {
              const infosAboutCsatOfThisGroup = dataCsat.find(
                (csatInfoOfThisGroup) => {
                  const hasId_grupo =
                    csatInfoOfThisGroup.id_grupo !== null &&
                    csatInfoOfThisGroup.id_grupo !== undefined;
                  const hasGroupId = groupId !== null && groupId !== undefined;
                  if (hasId_grupo && hasGroupId) {
                    return csatInfoOfThisGroup.id_grupo.toString() === groupId;
                  } else {
                    return false;
                  }
                }
              );

              const hasInfosAboutCsatOfThisGroup = !!infosAboutCsatOfThisGroup;
              const hasCsatGrade =
                hasInfosAboutCsatOfThisGroup &&
                typeof infosAboutCsatOfThisGroup.nota === "string" &&
                !!Number(infosAboutCsatOfThisGroup.nota);
              csatGrade = hasCsatGrade
                ? Number(infosAboutCsatOfThisGroup.nota)
                : 0;
            }

            if (hasDataOfGroup) {
              const groupName = dataOfGroup[0].nome_grupo;
              let promoters = 0;
              let neutrals = 0;
              let detractors = 0;
              let qtde = 0;
              let qtdeSent = 0;

              dataOfGroup.forEach((datum) => {
                qtde += Number(datum.qtde_avaliada);
                qtdeSent += Number(datum.qtde_enviada);
                switch (datum.nota) {
                  case "Promotor":
                    promoters += Number(datum.qtde_avaliada);
                    return;
                  case "promotor":
                    promoters += Number(datum.qtde_avaliada);
                    return;
                  case "Detrator":
                    detractors += Number(datum.qtde_avaliada);
                    return;
                  case "detrator":
                    detractors += Number(datum.qtde_avaliada);
                    return;
                  case "Neutro":
                    neutrals += Number(datum.qtde_avaliada);
                    return;
                  case "neutro":
                    neutrals += Number(datum.qtde_avaliada);
                    return;
                  default:
                    return;
                }
              });

              const total = promoters + neutrals + detractors;
              const calcNps = total
                ? (((promoters - detractors) / total) * 100).toFixed(2)
                : "0.00";

              updatedGroupData.push({
                "#": {
                  data: `${index + 1}`,
                  config: {
                    className: "",
                  },
                },
                unity: {
                  data: groupName,
                  config: {
                    className: "",
                  },
                },
                ranking: {
                  data: (
                    <RankingIndicator
                      promoterNumber={promoters}
                      detractorNumber={detractors}
                      neutralNumber={neutrals}
                    />
                  ),
                  config: {
                    className: "",
                  },
                },
                note: {
                  data: calcNps === "" ? "" : `${calcNps} NPS`,
                  config: {
                    className: "",
                  },
                },
                noteCsat: {
                  data: csatGrade,
                  config: {
                    className: "",
                  },
                },
                qtd: {
                  data: qtde_avaliou,
                  config: {
                    className: "",
                  },
                },
                sended: {
                  data: qtde_envio,
                  config: {
                    className: "",
                  },
                },
                answered: {
                  data: qtde_avaliou,
                  config: {
                    className: "",
                  },
                },
                "%": {
                  data: qtde_envio
                    ? ((qtde_avaliou / qtde_envio) * 100).toFixed(0) + "%"
                    : "",
                  config: {
                    className: "",
                  },
                },
              });
            }

            index++;
          }
        }
      }
      setUnityRawData(updatedGroupData);
      setFilteredUnityData(updatedGroupData);
      setLoadingUnity(false);
    } else {
      setUnityRawData(updatedGroupData);
      setFilteredUnityData(updatedGroupData);
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setErrorUnit(true);
          setLoadingUnity(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }

    //setSearchData("");
  }

  async function updateServicesTableContent(
    startDate,
    endDate,
    idsChannel,
    idsAvaliation,
    source
  ) {
    setErrorInsurance(false);
    setLoadingInsurance(true);

    let updatedServiceData = [];

    const response = await getRankingServiceCall(
      startDate,
      endDate,
      idsChannel,
      idsAvaliation,
      source
    );
    const hasResponse = !!response && response.status === 200;

    const responseTotalSended = await getRankingServiceCallEnviadas(
      startDate,
      endDate,
      idsChannel,
      idsAvaliation
    );
    const hasResponseTotalSended =
      !!responseTotalSended && responseTotalSended.status === 200;

    const responseCsatGrade = await getRankingServiceCallCsat(
      startDate,
      endDate,
      idsChannel,
      idsAvaliation
    );

    const hasResponseCsatGrade =
      !!responseCsatGrade && responseCsatGrade.status === 200;

    if (hasResponse && hasResponseTotalSended && hasResponseCsatGrade) {
      const data = response.data;
      const hasData = !!data && data.length > 0;

      const dataTotalSended = responseTotalSended.data;
      const hasDataTotalSended =
        !!dataTotalSended &&
        Array.isArray(dataTotalSended) &&
        dataTotalSended.length > 0;

      const dataCsat = responseCsatGrade.data;
      const hasDataCsat =
        !!dataCsat && Array.isArray(dataCsat) && dataCsat.length > 0;

      if (hasData) {
        const groupedData = groupBy(data, "id_servico");
        const hasGroupedData = !!groupedData;
        if (hasGroupedData) {
          let index = 0;
          for (const groupId in groupedData) {
            const dataOfGroup = groupedData[groupId];
            const hasDataOfGroup = !!dataOfGroup && dataOfGroup.length > 0;

            const infosAboutTotalSendedOfThisService = dataTotalSended.find(
              (sendedInfoOfThisService) => {
                const hasId_grupo =
                  sendedInfoOfThisService.id_servico !== null &&
                  sendedInfoOfThisService.id_servico !== undefined;
                const hasGroupId = groupId !== null && groupId !== undefined;
                if (hasId_grupo && hasGroupId) {
                  return (
                    sendedInfoOfThisService.id_servico.toString() === groupId
                  );
                } else {
                  return false;
                }
              }
            );
            const hasInfosAboutTotalSendedOfThisService =
              !!infosAboutTotalSendedOfThisService;
            const qtde_envio = hasInfosAboutTotalSendedOfThisService
              ? Number(infosAboutTotalSendedOfThisService.qtde_enviada)
              : 0;

            // pega a nota CSAT
            let csatGrade = 0;
            if (hasDataCsat) {
              const infosAboutCsatOfThisGroup = dataCsat.find(
                (csatInfoOfThisGroup) => {
                  const hasId_servico =
                    csatInfoOfThisGroup.id_servico !== null &&
                    csatInfoOfThisGroup.id_servico !== undefined;
                  const hasGroupId = groupId !== null && groupId !== undefined;
                  if (hasId_servico && hasGroupId) {
                    return (
                      csatInfoOfThisGroup.id_servico.toString() === groupId
                    );
                  } else {
                    return false;
                  }
                }
              );
              const hasInfosAboutCsatOfThisGroup = !!infosAboutCsatOfThisGroup;
              const hasCsatGrade =
                hasInfosAboutCsatOfThisGroup &&
                typeof infosAboutCsatOfThisGroup.nota === "string" &&
                !!Number(infosAboutCsatOfThisGroup.nota);
              csatGrade = hasCsatGrade
                ? Number(infosAboutCsatOfThisGroup.nota)
                : 0;
            }

            if (hasDataOfGroup) {
              const groupName = dataOfGroup[0].nome_servico;
              let promoters = 0;
              let neutrals = 0;
              let detractors = 0;
              let qtde = 0;
              let qtdeSent = 0;

              dataOfGroup.forEach((datum) => {
                qtde += Number(datum.qtde_avaliada);
                qtdeSent += Number(datum.qtde_enviada);
                switch (datum.nota) {
                  case "Promotor":
                    promoters += Number(datum.qtde_avaliada);
                    return;
                  case "promotor":
                    promoters += Number(datum.qtde_avaliada);
                    return;
                  case "Detrator":
                    detractors += Number(datum.qtde_avaliada);
                    return;
                  case "detrator":
                    detractors += Number(datum.qtde_avaliada);
                    return;
                  case "Neutro":
                    neutrals += Number(datum.qtde_avaliada);
                    return;
                  case "neutro":
                    neutrals += Number(datum.qtde_avaliada);
                    return;
                  default:
                    return;
                }
              });

              const total = promoters + neutrals + detractors;
              const calcNps = total
                ? (((promoters - detractors) / total) * 100).toFixed(2)
                : "0.00";

              updatedServiceData.push({
                "#": {
                  data: `${index + 1}`,
                  config: {
                    className: "",
                  },
                },
                unity: {
                  data: groupName,
                  config: {
                    className: "",
                  },
                },
                ranking: {
                  data: (
                    <RankingIndicator
                      promoterNumber={promoters}
                      detractorNumber={detractors}
                      neutralNumber={neutrals}
                    />
                  ),
                  config: {
                    className: "",
                  },
                },
                note: {
                  data: calcNps === "" ? "" : `${calcNps} NPS`,
                  config: {
                    className: "",
                  },
                },
                noteCsat: {
                  data: csatGrade,
                  config: {
                    className: "",
                  },
                },
                qtd: {
                  data: qtde,
                  config: {
                    className: "",
                  },
                },
                sended: {
                  data: qtde_envio,
                  config: {
                    className: "",
                  },
                },
                answered: {
                  data: qtde,
                  config: {
                    className: "",
                  },
                },
                "%": {
                  data: qtde_envio
                    ? ((qtde / qtde_envio) * 100).toFixed(0) + "%"
                    : "",
                  config: {
                    className: "",
                  },
                },
              });
            }

            index++;
          }
        }
      }
      setInsuranceRawData(updatedServiceData);
      setFilteredInsuranceData(updatedServiceData);
      setLoadingInsurance(false);
    } else {
      setInsuranceRawData(updatedServiceData);
      setFilteredInsuranceData(updatedServiceData);
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setErrorInsurance(true);
          setLoadingInsurance(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }

    //setSearchData("");
  }

  function filterDataWithSearch(searchData, rawData, type = "Unidades") {
    if (searchData && rawData && rawData.length) {
      const filteredData = rawData.filter((data) => {
        const unityComparation = data.unity.data
          ? data.unity.data
              .toString()
              .toLowerCase()
              .includes(searchData.toLowerCase())
          : false;
        const noteComparation = data.note.data
          ? data.note.data
              .toString()
              .toLowerCase()
              .includes(searchData.toLowerCase())
          : false;
        const qtdComparation =
          data.qtd.data || data.qtd.data === 0
            ? data.qtd.data
                .toString()
                .toLowerCase()
                .includes(searchData.toLowerCase())
            : false;
        const sendedComparation =
          data.sended.data || data.sended.data === 0
            ? data.sended.data
                .toString()
                .toLowerCase()
                .includes(searchData.toLowerCase())
            : false;
        const answeredComparation =
          data.answered.data || data.answered.data === 0
            ? data.answered.data
                .toString()
                .toLowerCase()
                .includes(searchData.toLowerCase())
            : false;
        const percentComparation = data["%"].data
          ? data["%"].data
              .toString()
              .toLowerCase()
              .includes(searchData.toLowerCase())
          : false;
        const csatComparation =
          data.noteCsat.data || data.noteCsat.data === 0
            ? data.noteCsat.data
                .toString()
                .toLowerCase()
                .includes(searchData.toLowerCase())
            : false;

        return (
          unityComparation ||
          noteComparation ||
          sendedComparation ||
          answeredComparation ||
          percentComparation ||
          csatComparation
        );
      });
      if (type === "Unidades" || type === "unidades") {
        setFilteredUnityData(filteredData ? filteredData : []);
      } else {
        setFilteredInsuranceData(filteredData ? filteredData : []);
      }
    } else {
      if (type === "Unidades" || type === "unidades") {
        setFilteredUnityData(rawData);
      } else {
        setFilteredInsuranceData(rawData);
      }
    }
  }

  const columnsTable = [
    {
      Header: "#",
      accessor: "#",
      id: "#",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: tabActive === "Unidades" ? "Grupo" : "Serviço",
      accessor: "unity",
      id: "unity",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "Ranking",
      accessor: "ranking",
      id: "ranking",
      disableFilters: true,
      disableSortBy: true,
      display: true,
    },
    {
      Header: "Nota",
      accessor: "note",
      id: "note",
      disableFilters: true,
      sortType: npsSorting,
      display: true,
    },
    {
      Header: "Nota CSAT",
      accessor: "noteCsat",
      id: "noteCsat",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "Enviadas",
      accessor: "sended",
      id: "sended",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "Respondidas",
      accessor: "answered",
      id: "answered",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "Adesão",
      accessor: "%",
      id: "%",
      disableFilters: true,
      sortType: feeSorting,
      display: true,
    },
  ];

  //USE EFFECTS

  useEffect(() => {
    const sourceGroups = axios.CancelToken.source();
    const sourceServices = axios.CancelToken.source();
    const startDate = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const endDate = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannels = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliations = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join();
    const idsGroups = agentDashboardFilter.groupSelectedAgentScreen
    .map((option) => option.id)
    .join(",")

    console.log("1234124124124", idsGroups)
    console.log("1234124124124", agentDashboardFilter)

    updateGroupsTableContent(
      startDate,
      endDate,
      idsChannels,
      idsAvaliations,
      sourceGroups,
      idsGroups
    );

    updateServicesTableContent(
      startDate,
      endDate,
      idsChannels,
      idsAvaliations,
      sourceServices
    );

    return () => {
      sourceGroups.cancel("Operation canceled by the user. (sourceGroups)");
      sourceServices.cancel("Operation canceled by the user. (sourceServices)");
    };
  }, [agentDashboardFilter]);

  useEffect(() => {
    if (!searchData) {
      setFilteredUnityData(unityRawData);
      setFilteredInsuranceData(insuranceRawData);
    }
  }, [searchData]);

  useEffect(() => {
    if (hasError) {
      toast.error(
        "Ocorreu um erro ao carregar as informações, tente novamente mais tarde!",
        { autoClose: 5000 }
      );
    }
  }, [hasError]);

  return (
    <div className="container-rankings" role="main">
      <ToastContainer />
      <header className="container-header">
        <div className="content-header">
          <h1 className="content-header__h4">Ranking</h1>

          <div className="container-input">
            <InputSearch
              search={searchData}
              setSearch={setSearchData}
              icon={<IconSearch />}
              placeholder="Pesquisar"
              onSearch={() => {
                filterDataWithSearch(searchData, unityRawData);
                filterDataWithSearch(
                  searchData,
                  insuranceRawData,
                  "Insurances"
                );
              }}
              onKeyDown={true}
            />
          </div>
        </div>
      </header>

      <div className="ranking-table-container">
        <nav className="filter-and-caption" aria-label="Ranking Filters">
          <div className="filter-and-caption__tabs">
            <div className="table-groups">
              <button
                className={`button-tabs ${
                  tabActive === "Unidades" ? "active" : ""
                }`}
                onClick={() => setTabActive("Unidades")}
              >
                <div className="button-tabs__text">
                  <h2 className="button-tabs__text__h5">Grupos</h2>
                </div>
              </button>

              <button
                className={`button-tabs ${
                  tabActive === "Convênios" ? "active" : ""
                }`}
                onClick={() => setTabActive("Convênios")}
              >
                <div className="button-tabs__text">
                  <h2 className="button-tabs__text__h5">Serviços</h2>
                </div>
              </button>
            </div>

            <span className="division" />
          </div>

          <div className="rankings" aria-label="Ranking Legend">
            <div className="district-promoter">
              <span className="district-promoter__color" />
              <h3 className="district-promoter__h6">Promotor</h3>
            </div>

            <div className="neutral">
              <span className="neutral__color" />
              <h3 className="neutral__h6">Neutro</h3>
            </div>

            <div className="detractor">
              <span className="detractor__color" />
              <h3 className="detractor__h6">Detrator</h3>
            </div>
          </div>
        </nav>

        {tabActive === "Unidades" ? (
          <section
            className="container-ranking-table"
            aria-labelledby="ranking-table-heading"
          >
            {loadingUnity ? (
              <Paperplane />
            ) : filteredUnityData && filteredUnityData.length ? (
              <Table
                fixedHeader
                className="ranking-table ranking-table-call-center"
                columns={columnsTable}
                data={filteredUnityData}
                classDivWrapperTable="ranking-table-wrapper-table"
                screen="npsTables"
              />
            ) : (
              <div className="container-ranking-table__empty">
                <EmptyState />
              </div>
            )}
          </section>
        ) : (
          <section
            className="container-ranking-table"
            aria-labelledby="ranking-table-heading"
          >
            {loadingInsurance ? (
              <Paperplane />
            ) : filteredInsuranceData && filteredInsuranceData.length ? (
              <Table
                fixedHeader
                className="ranking-table ranking-table-call-center"
                columns={columnsTable}
                data={filteredInsuranceData}
                classDivWrapperTable="ranking-table-wrapper-table"
                screen="npsTables"
              />
            ) : (
              <div className="container-ranking-table__empty">
                <EmptyState />
              </div>
            )}
          </section>
        )}
      </div>
    </div>
  );
}
